import React from "react";

interface TeamMember {
  name: string;
  role: string;
  description: string;
  imgSrc: string;
  socialLinks: {
    facebook: string;
    instagram: string;
    twitter: string;
  };
}

const teamMembers: TeamMember[] = [
  {
    name: "Jocelyn Schleifer",
    role: "Software Engineer",
    description:
      "There are many variations of passages of Lorem Ipsum available",
    imgSrc: "/assets/imgs/team1.png",
    socialLinks: {
      facebook: "/assets/imgs/team-facebook.svg",
      instagram: "/assets/imgs/team-instagram.svg",
      twitter: "/assets/imgs/team-twitter.svg",
    },
  },
  {
    name: "Alex Johnson",
    role: "UI/UX Designer",
    description: "Creating intuitive and engaging user experiences.",
    imgSrc: "/assets/imgs/team1.png",
    socialLinks: {
      facebook: "/assets/imgs/team-facebook.svg",
      instagram: "/assets/imgs/team-instagram.svg",
      twitter: "/assets/imgs/team-twitter.svg",
    },
  },
  {
    name: "Jamie Lee",
    role: "Product Manager",
    description: "Bridging the gap between engineering and design.",
    imgSrc: "/assets/imgs/team1.png",
    socialLinks: {
      facebook: "/assets/imgs/team-facebook.svg",
      instagram: "/assets/imgs/team-instagram.svg",
      twitter: "/assets/imgs/team-twitter.svg",
    },
  },
  {
    name: "Morgan Smith",
    role: "Backend Developer",
    description: "Building the infrastructure behind our applications.",
    imgSrc: "/assets/imgs/team1.png",
    socialLinks: {
      facebook: "/assets/imgs/team-facebook.svg",
      instagram: "/assets/imgs/team-instagram.svg",
      twitter: "/assets/imgs/team-twitter.svg",
    },
  },
];

const TeamCard: React.FC<TeamMember> = ({
  name,
  role,
  description,
  imgSrc,
  socialLinks,
}) => (
  <div className="col-lg-3 col-md-4 col-sm-6 mb-lg-0 mb-3">
    <div className="ourTeamCard">
      <img src={imgSrc} className="w-100" alt={name} />
      <div className="p-3">
        <h3>{name}</h3>
        <span>{role}</span>
        <p className="text-start">{description}</p>
        <div className="d-flex gap-3 mt-4">
          {Object.entries(socialLinks).map(([key, src]) => (
            <div className="iconMain" key={key}>
              <img src={src} alt={`${key} icon`} />
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

function OurTeam() {
  return (
    <div className="ourTeam">
      <h2>Meet the Boll-e&trade; team</h2>
      <p>
        There are many variations of passages of Lorem Ipsum available, but the
        majority have suffered in some form, by injected humour
      </p>
      <div className="row mt-5">
        {teamMembers.map((member, index) => (
          <TeamCard key={index} {...member} />
        ))}
      </div>
    </div>
  );
}

export default OurTeam;
